import { Injectable } from "@angular/core";
import { JobService } from "../../services/job.service";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { JobsActions } from "./jobs.actions";
import { map, mergeMap, tap } from "rxjs";
import { Job } from "../../class/job.class";

@Injectable()
export class JobsEffect {
  constructor(
    private action$: Actions,
    private jobService: JobService
  ) { }

  loadJobs$ = createEffect(() =>
    this.action$.pipe(
      ofType(JobsActions.loadJobs),
      mergeMap(() =>
        this.jobService.getClientJobs().pipe(
          map((jobs: Job[]) => JobsActions.addJobs({ jobs }))
        )
      )
    )
  );

}